import _objectWithoutProperties from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _objectSpread from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";
import _asyncToGenerator from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _toConsumableArray from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var methodName = context.method, method = delegate.iterator[methodName]; if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel; var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
import { lazy } from 'react';
import { autorun, observable } from 'mobx';
import { cast, types, addDisposer } from 'mobx-state-tree';
import copy from 'copy-to-clipboard';
import { ConfigurationReference, readConfObject, getConf } from '@jbrowse/core/configuration';
import { getRpcSessionId } from '@jbrowse/core/util/tracks';
import { getEnv, getSession, isSessionModelWithWidgets, getContainingView, SimpleFeature } from '@jbrowse/core/util';
import { BaseLinearDisplay } from '@jbrowse/plugin-linear-genome-view';
// icons
import VisibilityIcon from '@mui/icons-material/Visibility';
import { ContentCopy as ContentCopyIcon } from '@jbrowse/core/ui/Icons';
import MenuOpenIcon from '@mui/icons-material/MenuOpen';
import SortIcon from '@mui/icons-material/Sort';
import PaletteIcon from '@mui/icons-material/Palette';
import FilterListIcon from '@mui/icons-material/ClearAll';
// locals
import LinearPileupDisplayBlurb from './components/LinearPileupDisplayBlurb';
import { getUniqueTagValues, getUniqueModificationValues, FilterModel } from '../shared';
// async
var FilterByTagDlg = lazy(function () {
  return import('../shared/FilterByTag');
});
var ColorByTagDlg = lazy(function () {
  return import('./components/ColorByTag');
});
var SortByTagDlg = lazy(function () {
  return import('./components/SortByTag');
});
var SetFeatureHeightDlg = lazy(function () {
  return import('./components/SetFeatureHeight');
});
var SetMaxHeightDlg = lazy(function () {
  return import('./components/SetMaxHeight');
});
var ModificationsDlg = lazy(function () {
  return import('./components/ColorByModifications');
});
// using a map because it preserves order
var rendererTypes = new Map([['pileup', 'PileupRenderer'], ['svg', 'SvgFeatureRenderer']]);
/**
 * #stateModel LinearPileupDisplay
 * extends `BaseLinearDisplay`
 */
function stateModelFactory(configSchema) {
  return types.compose('LinearPileupDisplay', BaseLinearDisplay, types.model({
    /**
     * #property
     */
    type: types.literal('LinearPileupDisplay'),
    /**
     * #property
     */
    configuration: ConfigurationReference(configSchema),
    /**
     * #property
     */
    showSoftClipping: false,
    /**
     * #property
     */
    featureHeight: types.maybe(types.number),
    /**
     * #property
     */
    noSpacing: types.maybe(types.boolean),
    /**
     * #property
     */
    fadeLikelihood: types.maybe(types.boolean),
    /**
     * #property
     */
    trackMaxHeight: types.maybe(types.number),
    /**
     * #property
     */
    mismatchAlpha: types.maybe(types.boolean),
    /**
     * #property
     */
    sortedBy: types.maybe(types.model({
      type: types.string,
      pos: types.number,
      tag: types.maybe(types.string),
      refName: types.string,
      assemblyName: types.string
    })),
    /**
     * #property
     */
    colorBy: types.maybe(types.model({
      type: types.string,
      tag: types.maybe(types.string),
      extra: types.frozen()
    })),
    /**
     * #property
     */
    filterBy: types.optional(FilterModel, {})
  })).volatile(function () {
    return {
      colorTagMap: observable.map({}),
      modificationTagMap: observable.map({}),
      featureUnderMouseVolatile: undefined,
      currSortBpPerPx: 0,
      ready: false
    };
  }).actions(function (self) {
    return {
      /**
       * #action
       */
      setReady: function setReady(flag) {
        self.ready = flag;
      },
      /**
       * #action
       */
      setCurrSortBpPerPx: function setCurrSortBpPerPx(n) {
        self.currSortBpPerPx = n;
      },
      /**
       * #action
       */
      setMaxHeight: function setMaxHeight(n) {
        self.trackMaxHeight = n;
      },
      /**
       * #action
       */
      setFeatureHeight: function setFeatureHeight(n) {
        self.featureHeight = n;
      },
      /**
       * #action
       */
      setNoSpacing: function setNoSpacing(flag) {
        self.noSpacing = flag;
      },
      /**
       * #action
       */
      setColorScheme: function setColorScheme(colorScheme) {
        self.colorTagMap = observable.map({}); // clear existing mapping
        self.colorBy = cast(colorScheme);
        self.ready = false;
      },
      /**
       * #action
       */
      updateModificationColorMap: function updateModificationColorMap(uniqueModifications) {
        var colorPalette = ['red', 'blue', 'green', 'orange', 'purple'];
        uniqueModifications.forEach(function (value) {
          if (!self.modificationTagMap.has(value)) {
            var totalKeys = _toConsumableArray(self.modificationTagMap.keys()).length;
            var newColor = colorPalette[totalKeys];
            self.modificationTagMap.set(value, newColor);
          }
        });
      },
      /**
       * #action
       */
      updateColorTagMap: function updateColorTagMap(uniqueTag) {
        // pale color scheme
        // https://cran.r-project.org/web/packages/khroma/vignettes/tol.html
        // e.g. "tol_light"
        var colorPalette = ['#BBCCEE', 'pink', '#CCDDAA', '#EEEEBB', '#FFCCCC', 'lightblue', 'lightgreen', 'tan', '#CCEEFF', 'lightsalmon'];
        uniqueTag.forEach(function (value) {
          if (!self.colorTagMap.has(value)) {
            var totalKeys = _toConsumableArray(self.colorTagMap.keys()).length;
            var newColor = colorPalette[totalKeys];
            self.colorTagMap.set(value, newColor);
          }
        });
      },
      /**
       * #action
       */
      setFeatureUnderMouse: function setFeatureUnderMouse(feat) {
        self.featureUnderMouseVolatile = feat;
      }
    };
  }).actions(function (self) {
    return {
      afterAttach: function afterAttach() {
        addDisposer(self, autorun( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
          var _getSession, rpcManager, view, sortedBy, colorBy, parentTrack, adapterConfig, rendererType, staticBlocks, bpPerPx, adapter, pos, refName, assemblyName;
          return _regeneratorRuntime().wrap(function _callee$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _getSession = getSession(self), rpcManager = _getSession.rpcManager;
                view = getContainingView(self);
                sortedBy = self.sortedBy, colorBy = self.colorBy, parentTrack = self.parentTrack, adapterConfig = self.adapterConfig, rendererType = self.rendererType;
                if (!(!view.initialized || !self.estimatedStatsReady || self.regionTooLarge)) {
                  _context.next = 6;
                  break;
                }
                return _context.abrupt("return");
              case 6:
                staticBlocks = view.staticBlocks, bpPerPx = view.bpPerPx; // continually generate the vc pairing, set and rerender if any
                // new values seen
                if (!(colorBy === null || colorBy === void 0 ? void 0 : colorBy.tag)) {
                  _context.next = 13;
                  break;
                }
                _context.t0 = self;
                _context.next = 11;
                return getUniqueTagValues(self, colorBy, staticBlocks);
              case 11:
                _context.t1 = _context.sent;
                _context.t0.updateColorTagMap.call(_context.t0, _context.t1);
              case 13:
                if (!((colorBy === null || colorBy === void 0 ? void 0 : colorBy.type) === 'modifications')) {
                  _context.next = 20;
                  break;
                }
                adapter = getConf(parentTrack, ['adapter']);
                _context.t2 = self;
                _context.next = 18;
                return getUniqueModificationValues(self, adapter, colorBy, staticBlocks);
              case 18:
                _context.t3 = _context.sent;
                _context.t2.updateModificationColorMap.call(_context.t2, _context.t3);
              case 20:
                if (!sortedBy) {
                  _context.next = 28;
                  break;
                }
                pos = sortedBy.pos, refName = sortedBy.refName, assemblyName = sortedBy.assemblyName; // render just the sorted region first
                // @ts-ignore
                _context.next = 24;
                return self.rendererType.renderInClient(rpcManager, _objectSpread({
                  assemblyName: assemblyName,
                  regions: [{
                    start: pos,
                    end: pos + 1,
                    refName: refName,
                    assemblyName: assemblyName
                  }],
                  adapterConfig: adapterConfig,
                  rendererType: rendererType.name,
                  sessionId: getRpcSessionId(self),
                  layoutId: view.id,
                  timeout: 1000000
                }, self.renderProps()));
              case 24:
                self.setReady(true);
                self.setCurrSortBpPerPx(bpPerPx);
                _context.next = 29;
                break;
              case 28:
                self.setReady(true);
              case 29:
                _context.next = 35;
                break;
              case 31:
                _context.prev = 31;
                _context.t4 = _context["catch"](0);
                console.error(_context.t4);
                self.setError(_context.t4);
              case 35:
              case "end":
                return _context.stop();
            }
          }, _callee, null, [[0, 31]]);
        })), {
          delay: 1000
        }));
        // autorun synchronizes featureUnderMouse with featureIdUnderMouse
        // asynchronously. this is needed due to how we do not serialize all
        // features from the BAM/CRAM over the rpc
        addDisposer(self, autorun( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
          var _a, session, featureId, sessionId, view, _yield$session$rpcMan, feature;
          return _regeneratorRuntime().wrap(function _callee2$(_context2) {
            while (1) switch (_context2.prev = _context2.next) {
              case 0:
                session = getSession(self);
                _context2.prev = 1;
                featureId = self.featureIdUnderMouse;
                if (!(((_a = self.featureUnderMouse) === null || _a === void 0 ? void 0 : _a.id()) !== featureId)) {
                  _context2.next = 15;
                  break;
                }
                if (featureId) {
                  _context2.next = 8;
                  break;
                }
                self.setFeatureUnderMouse(undefined);
                _context2.next = 15;
                break;
              case 8:
                sessionId = getRpcSessionId(self);
                view = getContainingView(self);
                _context2.next = 12;
                return session.rpcManager.call(sessionId, 'CoreGetFeatureDetails', {
                  featureId: featureId,
                  sessionId: sessionId,
                  layoutId: view.id,
                  rendererType: 'PileupRenderer'
                });
              case 12:
                _yield$session$rpcMan = _context2.sent;
                feature = _yield$session$rpcMan.feature;
                // check featureIdUnderMouse is still the same as the
                // feature.id that was returned e.g. that the user hasn't
                // moused over to a new position during the async operation
                // above
                // @ts-ignore
                if (self.featureIdUnderMouse === feature.uniqueId) {
                  // @ts-ignore
                  self.setFeatureUnderMouse(new SimpleFeature(feature));
                }
              case 15:
                _context2.next = 21;
                break;
              case 17:
                _context2.prev = 17;
                _context2.t0 = _context2["catch"](1);
                console.error(_context2.t0);
                session.notify("".concat(_context2.t0), 'error');
              case 21:
              case "end":
                return _context2.stop();
            }
          }, _callee2, null, [[1, 17]]);
        }))));
      },
      /**
       * #action
       */
      selectFeature: function selectFeature(feature) {
        var session = getSession(self);
        if (isSessionModelWithWidgets(session)) {
          var featureWidget = session.addWidget('AlignmentsFeatureWidget', 'alignmentFeature', {
            featureData: feature.toJSON(),
            view: getContainingView(self)
          });
          session.showWidget(featureWidget);
        }
        session.setSelection(feature);
      },
      /**
       * #action
       */
      clearSelected: function clearSelected() {
        self.sortedBy = undefined;
      },
      /**
       * #action
       * uses copy-to-clipboard and generates notification
       */
      copyFeatureToClipboard: function copyFeatureToClipboard(feature) {
        var _feature$toJSON = feature.toJSON(),
          uniqueId = _feature$toJSON.uniqueId,
          rest = _objectWithoutProperties(_feature$toJSON, ["uniqueId"]);
        var session = getSession(self);
        copy(JSON.stringify(rest, null, 4));
        session.notify('Copied to clipboard', 'success');
      },
      /**
       * #action
       */
      toggleSoftClipping: function toggleSoftClipping() {
        self.showSoftClipping = !self.showSoftClipping;
      },
      /**
       * #action
       */
      toggleMismatchAlpha: function toggleMismatchAlpha() {
        self.mismatchAlpha = !self.mismatchAlpha;
      },
      /**
       * #action
       */
      setConfig: function setConfig(configuration) {
        self.configuration = configuration;
      },
      /**
       * #action
       */
      setSortedBy: function setSortedBy(type, tag) {
        var _getContainingView = getContainingView(self),
          centerLineInfo = _getContainingView.centerLineInfo;
        if (!centerLineInfo) {
          return;
        }
        var refName = centerLineInfo.refName,
          assemblyName = centerLineInfo.assemblyName,
          offset = centerLineInfo.offset;
        var centerBp = Math.round(offset) + 1;
        if (centerBp < 0 || !refName) {
          return;
        }
        self.sortedBy = {
          type: type,
          pos: centerBp,
          refName: refName,
          assemblyName: assemblyName,
          tag: tag
        };
        self.ready = false;
      },
      setFilterBy: function setFilterBy(filter) {
        self.filterBy = cast(filter);
      }
    };
  }).actions(function (self) {
    // resets the sort object and refresh whole display on reload
    var superReload = self.reload;
    return {
      /**
       * #action
       */
      reload: function reload() {
        self.clearSelected();
        superReload();
      }
    };
  }).views(function (self) {
    return {
      /**
       * #getter
       */
      get maxHeight() {
        var conf = getConf(self, ['renderers', self.rendererTypeName]) || {};
        return self.trackMaxHeight !== undefined ? self.trackMaxHeight : conf.maxHeight;
      },
      /**
       * #getter
       */
      get rendererConfig() {
        var configBlob = getConf(self, ['renderers', self.rendererTypeName]) || {};
        return self.rendererType.configSchema.create(_objectSpread({}, configBlob, {
          height: self.featureHeight,
          noSpacing: self.noSpacing,
          maxHeight: this.maxHeight,
          mismatchAlpha: self.mismatchAlpha
        }), getEnv(self));
      },
      /**
       * #getter
       */
      get featureHeightSetting() {
        return self.featureHeight || readConfObject(this.rendererConfig, 'height');
      },
      /**
       * #getter
       */
      get mismatchAlphaSetting() {
        return self.mismatchAlpha !== undefined ? self.mismatchAlpha : readConfObject(this.rendererConfig, 'mismatchAlpha');
      },
      /**
       * #getter
       */
      get featureUnderMouse() {
        return self.featureUnderMouseVolatile;
      }
    };
  }).views(function (self) {
    var superTrackMenuItems = self.trackMenuItems,
      superRenderProps = self.renderProps;
    return {
      /**
       * #getter
       */
      get rendererTypeName() {
        var viewName = getConf(self, 'defaultRendering');
        var rendererType = rendererTypes.get(viewName);
        if (!rendererType) {
          throw new Error("unknown alignments view name ".concat(viewName));
        }
        return rendererType;
      },
      /**
       * #method
       */
      contextMenuItems: function contextMenuItems() {
        var feat = self.contextMenuFeature;
        var contextMenuItems = feat ? [{
          label: 'Open feature details',
          icon: MenuOpenIcon,
          onClick: function onClick() {
            self.clearFeatureSelection();
            if (feat) {
              self.selectFeature(feat);
            }
          }
        }, {
          label: 'Copy info to clipboard',
          icon: ContentCopyIcon,
          onClick: function onClick() {
            if (feat) {
              self.copyFeatureToClipboard(feat);
            }
          }
        }] : [];
        return contextMenuItems;
      },
      /**
       * #getter
       */
      get DisplayBlurb() {
        return LinearPileupDisplayBlurb;
      },
      /**
       * #method
       */
      renderProps: function renderProps() {
        var view = getContainingView(self);
        var colorTagMap = self.colorTagMap,
          modificationTagMap = self.modificationTagMap,
          sortedBy = self.sortedBy,
          colorBy = self.colorBy,
          filterBy = self.filterBy,
          rpcDriverName = self.rpcDriverName,
          currSortBpPerPx = self.currSortBpPerPx,
          ready = self.ready;
        var superProps = superRenderProps();
        return _objectSpread({}, superProps, {
          notReady: superProps.notReady || !ready || sortedBy && currSortBpPerPx !== view.bpPerPx,
          rpcDriverName: rpcDriverName,
          displayModel: self,
          sortedBy: sortedBy,
          colorBy: colorBy,
          filterBy: JSON.parse(JSON.stringify(filterBy)),
          colorTagMap: Object.fromEntries(colorTagMap.toJSON()),
          modificationTagMap: Object.fromEntries(modificationTagMap.toJSON()),
          showSoftClip: self.showSoftClipping,
          config: self.rendererConfig,
          onFeatureClick: function () {
            var _onFeatureClick = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(_, featureId) {
              var session, rpcManager, f, sessionId, _yield$rpcManager$cal, feature;
              return _regeneratorRuntime().wrap(function _callee3$(_context3) {
                while (1) switch (_context3.prev = _context3.next) {
                  case 0:
                    session = getSession(self);
                    rpcManager = session.rpcManager;
                    _context3.prev = 2;
                    f = featureId || self.featureIdUnderMouse;
                    if (f) {
                      _context3.next = 8;
                      break;
                    }
                    self.clearFeatureSelection();
                    _context3.next = 14;
                    break;
                  case 8:
                    sessionId = getRpcSessionId(self);
                    _context3.next = 11;
                    return rpcManager.call(sessionId, 'CoreGetFeatureDetails', {
                      featureId: f,
                      sessionId: sessionId,
                      layoutId: getContainingView(self).id,
                      rendererType: 'PileupRenderer'
                    });
                  case 11:
                    _yield$rpcManager$cal = _context3.sent;
                    feature = _yield$rpcManager$cal.feature;
                    if (feature) {
                      // @ts-ignore
                      self.selectFeature(new SimpleFeature(feature));
                    }
                  case 14:
                    _context3.next = 20;
                    break;
                  case 16:
                    _context3.prev = 16;
                    _context3.t0 = _context3["catch"](2);
                    console.error(_context3.t0);
                    session.notify("".concat(_context3.t0));
                  case 20:
                  case "end":
                    return _context3.stop();
                }
              }, _callee3, null, [[2, 16]]);
            }));
            function onFeatureClick(_x, _x2) {
              return _onFeatureClick.apply(this, arguments);
            }
            return onFeatureClick;
          }(),
          onClick: function onClick() {
            self.clearFeatureSelection();
          },
          // similar to click but opens a menu with further options
          onFeatureContextMenu: function () {
            var _onFeatureContextMenu = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(_, featureId) {
              var session, rpcManager, f, sessionId, _yield$rpcManager$cal2, feature;
              return _regeneratorRuntime().wrap(function _callee4$(_context4) {
                while (1) switch (_context4.prev = _context4.next) {
                  case 0:
                    session = getSession(self);
                    rpcManager = session.rpcManager;
                    _context4.prev = 2;
                    f = featureId || self.featureIdUnderMouse;
                    if (f) {
                      _context4.next = 8;
                      break;
                    }
                    self.clearFeatureSelection();
                    _context4.next = 14;
                    break;
                  case 8:
                    sessionId = getRpcSessionId(self);
                    _context4.next = 11;
                    return rpcManager.call(sessionId, 'CoreGetFeatureDetails', {
                      featureId: f,
                      sessionId: sessionId,
                      layoutId: getContainingView(self).id,
                      rendererType: 'PileupRenderer'
                    });
                  case 11:
                    _yield$rpcManager$cal2 = _context4.sent;
                    feature = _yield$rpcManager$cal2.feature;
                    if (feature) {
                      self.setContextMenuFeature(new SimpleFeature(feature));
                    }
                  case 14:
                    _context4.next = 20;
                    break;
                  case 16:
                    _context4.prev = 16;
                    _context4.t0 = _context4["catch"](2);
                    console.error(_context4.t0);
                    session.notify("".concat(_context4.t0));
                  case 20:
                  case "end":
                    return _context4.stop();
                }
              }, _callee4, null, [[2, 16]]);
            }));
            function onFeatureContextMenu(_x3, _x4) {
              return _onFeatureContextMenu.apply(this, arguments);
            }
            return onFeatureContextMenu;
          }()
        });
      },
      /**
       * #method
       */
      trackMenuItems: function trackMenuItems() {
        return [].concat(_toConsumableArray(superTrackMenuItems()), [{
          label: 'Show soft clipping',
          icon: VisibilityIcon,
          type: 'checkbox',
          checked: self.showSoftClipping,
          onClick: function onClick() {
            self.toggleSoftClipping();
            // if toggling from off to on, will break sort for this track
            // so clear it
            if (self.showSoftClipping) {
              self.clearSelected();
            }
          }
        }, {
          label: 'Sort by',
          icon: SortIcon,
          disabled: self.showSoftClipping,
          subMenu: [].concat(_toConsumableArray(['Start location', 'Read strand', 'Base pair'].map(function (option) {
            return {
              label: option,
              onClick: function onClick() {
                return self.setSortedBy(option);
              }
            };
          })), [{
            label: 'Sort by tag...',
            onClick: function onClick() {
              getSession(self).queueDialog(function (handleClose) {
                return [SortByTagDlg, {
                  model: self,
                  handleClose: handleClose
                }];
              });
            }
          }, {
            label: 'Clear sort',
            onClick: function onClick() {
              return self.clearSelected();
            }
          }])
        }, {
          label: 'Color scheme',
          icon: PaletteIcon,
          subMenu: [{
            label: 'Normal',
            onClick: function onClick() {
              return self.setColorScheme({
                type: 'normal'
              });
            }
          }, {
            label: 'Mapping quality',
            onClick: function onClick() {
              return self.setColorScheme({
                type: 'mappingQuality'
              });
            }
          }, {
            label: 'Strand',
            onClick: function onClick() {
              return self.setColorScheme({
                type: 'strand'
              });
            }
          }, {
            label: 'Pair orientation',
            onClick: function onClick() {
              return self.setColorScheme({
                type: 'pairOrientation'
              });
            }
          }, {
            label: 'Per-base quality',
            onClick: function onClick() {
              return self.setColorScheme({
                type: 'perBaseQuality'
              });
            }
          }, {
            label: 'Per-base lettering',
            onClick: function onClick() {
              return self.setColorScheme({
                type: 'perBaseLettering'
              });
            }
          }, {
            label: 'Modifications or methylation',
            onClick: function onClick() {
              getSession(self).queueDialog(function (doneCallback) {
                return [ModificationsDlg, {
                  model: self,
                  handleClose: doneCallback
                }];
              });
            }
          }, {
            label: 'Insert size',
            onClick: function onClick() {
              return self.setColorScheme({
                type: 'insertSize'
              });
            }
          }, {
            label: 'Stranded paired-end',
            onClick: function onClick() {
              return self.setColorScheme({
                type: 'reverseTemplate'
              });
            }
          }, {
            label: 'Color by tag...',
            onClick: function onClick() {
              getSession(self).queueDialog(function (doneCallback) {
                return [ColorByTagDlg, {
                  model: self,
                  handleClose: doneCallback
                }];
              });
            }
          }]
        }, {
          label: 'Filter by',
          icon: FilterListIcon,
          onClick: function onClick() {
            getSession(self).queueDialog(function (doneCallback) {
              return [FilterByTagDlg, {
                model: self,
                handleClose: doneCallback
              }];
            });
          }
        }, {
          label: 'Set feature height',
          subMenu: [{
            label: 'Normal',
            onClick: function onClick() {
              self.setFeatureHeight(7);
              self.setNoSpacing(false);
            }
          }, {
            label: 'Compact',
            onClick: function onClick() {
              self.setFeatureHeight(2);
              self.setNoSpacing(true);
            }
          }, {
            label: 'Manually set height',
            onClick: function onClick() {
              getSession(self).queueDialog(function (doneCallback) {
                return [SetFeatureHeightDlg, {
                  model: self,
                  handleClose: doneCallback
                }];
              });
            }
          }]
        }, {
          label: 'Set max height',
          onClick: function onClick() {
            getSession(self).queueDialog(function (doneCallback) {
              return [SetMaxHeightDlg, {
                model: self,
                handleClose: doneCallback
              }];
            });
          }
        }, {
          label: 'Fade mismatches by quality',
          type: 'checkbox',
          checked: self.mismatchAlphaSetting,
          onClick: function onClick() {
            return self.toggleMismatchAlpha();
          }
        }]);
      }
    };
  });
}
export default stateModelFactory;